export default __webpack_public_path__ + "static/media/adi-kaidar-yardeni.906f543c.png";